import {
  ShipmentFragment,
  ShipmentPreviewFragment,
} from '@shared/generated/graphql';
import { movementPreviewFromFragment } from '@shared/graphql/fromFragments/movement';
import { Shipment, ShipmentPreview } from '@shared/types/shipment';
import { ScheduleStop } from 'clerk_common/types';

export function shipmentPreviewFromFragment(
  fragment?: ShipmentPreviewFragment
): ShipmentPreview {
  return {
    id: fragment?.id ?? '',
    createdAt: new Date(fragment?.createdAt ?? ''),
    movementPreviews:
      fragment?.movements.map(movementPreviewFromFragment) ?? [],
    referenceNumbers: fragment?.referenceNumbers ?? [],
    user: fragment?.user
      ? {
          id: fragment.user.id,
          email: fragment.user.email ?? undefined,
          firstName: fragment.user.firstName ?? undefined,
          lastName: fragment.user.lastName ?? undefined,
        }
      : undefined,
  };
}

export function shipmentFromFragment(fragment?: ShipmentFragment): Shipment {
  return {
    ...shipmentPreviewFromFragment(fragment),
    stops: toStops(fragment?.schedulingInfo.stops),
    tmsId: fragment?.schedulingInfo.tmsId ?? undefined,
    trackingInfo: {
      driverName: fragment?.trackingInfo.driverName ?? undefined,
      driverPhone: fragment?.trackingInfo.driverPhone ?? undefined,
    },
  };
}

// NOTE(jonathan): I'm not sure how to avoid fighting the type system here.
// I realize it's my fault by doing:
// export class ShipmentSchedulingInfoPayload {
//   @Field(() => [GraphQLJSON])    <------ THIS
//   stops!: ScheduleStop[];
// But I do that because I'm frequently changing ScheduleStop and want to avoid
// repeating myself in GraphQL files.

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function toStops(stops?: any[]): ScheduleStop[] {
  if (!stops) return [];
  return stops.map((s) => toStop(s));
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function toStop(stop: any): ScheduleStop {
  const ss: ScheduleStop = {
    ...stop,
    portalAvailTimes: toAvailTimes(stop.portalAvailTimes),
  };
  return ss;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function toAvailTimes(times?: any[]): Date[] {
  if (!times) return [];
  return times.map((t) => new Date(t));
}
